import { BEM } from '@feedfm/feed-util';
import React from 'react';
import { ContentSourceDetailsFragment } from '~/graphqlTypes/ContentSourceDetailsFragment';
import { AudioFileAvailabilityFragment } from '~/graphqlTypes/AudioFileAvailabilityFragment';
import { AudioFileAvailabilityTable } from '~/components/AudioFileAvailabilityTable/AudioFileAvailabilityTable';
import { Widget } from '~/components/Widget/Widget';

export interface ContentSourceDetailsDefaultRightsProps {
  source: ContentSourceDetailsFragment;
  handleUpdateRights: (
    updated: AudioFileAvailabilityFragment,
    original?: AudioFileAvailabilityFragment,
  ) => Promise<void>;
  handleDeleteRights: ( right: AudioFileAvailabilityFragment ) => Promise<void>;
}

export const ContentSourceDetailDefaultRights: React.FC<ContentSourceDetailsDefaultRightsProps> = ( props ) => {
  const { handleDeleteRights, handleUpdateRights, source: { defaultRights: rights } } = props;
  const tableProps = { handleDeleteRights, handleUpdateRights, rights };
  const bem = new BEM( 'ops-catalog-sources-detail-default-rights', [] );

  return (
    <article className={ BEM.$( bem ) }>
      <Widget title="Default Rights" titleElement="h4">
        <AudioFileAvailabilityTable { ...tableProps } />
      </Widget>
    </article>
  );
};
